export class MacroAddProcedureDto {
  Id: string;
  ProcedureId: string; // only field required for saving a new macro procedure
  Code: string;
  CodeDescription: string;
}
